import { postBodyMdsService } from "./oauth.service";
import config from "../config/application";
import env from "../config/env";
class PermissionService {
    validPermission(transactionCode, username, systemCode, action) {
        const jsonData = {
            transactionCode: transactionCode,
            username: username,
            systemCode: systemCode,
            action: action
        }
        
        const url = `${config.data.security.permission.url}${env.mds.query}`;
        return postBodyMdsService(url, jsonData);
    }
}

export default new PermissionService();